const creationFormState = {
  task_type: "AWARNESS_TASK",
  task_heading: null,
  start_date: null,
  end_date: null,
  description: null,
  csv_file: null,
  audio_file: null,
};

export const editFormState = {
  start_date: "2023-11-04 00:00:00.000",
  end_date: "2023-11-05 00:00:00.000",
  created_by: "ahmed.arsalan@zomato.com",
  task_type: "AWARNESS_TASK",
  task_heading: "Diwali Login Calling",
  status: "Started",
  description: "we need more logins for Diwali",
  task_id: "001",
  note: "URL",
  mapping: "CSV_URL",
  id: "001",
  csv_file: null,
  audio_file: null,
};

export const Form_Action = {
  EDIT: "edit",
  DELETE: "delete",
};

export const InstructionsCSVUpload = [
  "Provide delivery driver IDs (e.g. FE34897) as per format given in the sample CSV.",
];

export default creationFormState;
